import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '@/contexts/SharedAuthContext';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAvatarUrl } from '@/hooks/useAvatarUrl';

export function UserButton() {
  const { t } = useTranslation();
  const { user, isLoading, logout } = useAuth();
  const navigate = useNavigate();
  const avatarUrl = useAvatarUrl();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success(t('auth.sign_out_success'));
    } catch {
      toast.error(t('auth.sign_out_error'));
    }
  };

  if (isLoading || !user) {
    return null;
  }

  // Generate initials avatar
  const initials = user.name
    ? user.name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()
    : user.email[0].toUpperCase();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-gray1 text-white font-semibold cursor-pointer border border-white/20 hover:bg-[#333333] transition-colors text-sm overflow-hidden"
          aria-label={t('auth.userbutton.user_menu')}
        >
          {avatarUrl
            ? <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
            : initials
          }
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <div className="my-3 flex items-center gap-3 px-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-gray1 text-white font-semibold text-sm shrink-0 overflow-hidden">
            {avatarUrl
              ? <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
              : initials
            }
          </div>
          <div className="flex flex-col flex-1 min-w-0">
            <p className="font-semibold truncate">{user.name}</p>
            <p className="text-xs text-muted-foreground truncate">{user.email}</p>
            <p className="text-xs text-muted-foreground truncate capitalize">{user.role}</p>
          </div>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/profile')} className="cursor-pointer gap-3">
          <User className="h-4 w-4" />
          <span>{t('auth.profile_settings')}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer gap-3 text-destructive">
          <LogOut className="h-4 w-4" />
          <span>{t('auth.sign_out')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
